import React, { Component } from 'react'
import moment from 'moment'
import numeral from 'numeral'
import SingleView from '../../components/SingleView'
import { Pagination } from 'antd'
import { drop } from 'lodash'

class Items extends Component {
  constructor(props) {
    super(props)
    this.state = {
      page: 1
    }
  }

  setPage = page => {
    this.setState({
      page
    })
  }

  getPagedData = () => {
    const { page } = this.state
    const data = this.props.items
    const offset = (page - 1) * 10
    return drop(data, offset).slice(0, 10)
  }

  render() {
    return (
      <div className="">
        <div className="jobsBar">Items</div>
        <SingleView
          title="Items"
          emptyText="No items for this vendor"
          data={this.getPagedData()}
          getKey={c => c.id}
          getHeader={c => c.name}
        >
          {i => (
            <div className="row">
              <div className="col-md-4">
                <div className="jobDetailsHeader">Name:</div>
                <span>{i.name}</span>
              </div>
              <div className="col-md-2">
                <div className="jobDetailsHeader">Cost:</div>
                <span>{numeral(i.cost).format('$0,0.00')}</span>
              </div>
              <div className="col-md-2">
                <div className="jobDetailsHeader">Overhead:</div>
                <span>{numeral(i.overhead).format('$0,0.00')}</span>
              </div>
              <div className="col-md-2">
                <div className="jobDetailsHeader">Markup:</div>
                <span>{numeral(i.markup).format('$0,0.00')}</span>
              </div>
              <div className="col-md-2">
                <div className="jobDetailsHeader">Updated:</div>
                <span>{moment.utc(i.updated_date).format('M/D/YYYY')}</span>
              </div>
            </div>
          )}
        </SingleView>
        <Pagination
          total={this.props.items ? this.props.items.length : 0}
          pageSize={10}
          current={this.state.page}
          defaultCurrent={1}
          onChange={this.setPage}
        />
      </div>
    )
  }
}

export default Items



// WEBPACK FOOTER //
// ./src/components/vendor/Items.js